module.exports = __webpack_public_path__ + "static/mindswarms-bw-min-78dc3d35f026c91613ca002c87f4db08.jpg";